import { Navigate, useLocation } from 'react-router-dom'
import { useMobileWebProfile } from '../hooks/useMobileWebProfile'

/**
 * Redirects admin users on mobile web away from routes outside their mobile_app_profile.
 */
export default function MobileWebRouteGuard({ children }) {
  const location = useLocation()
  const { appliesMobileProfile, defaultRoute, isPathAllowed } = useMobileWebProfile()

  if (!appliesMobileProfile) {
    return children
  }

  if (!isPathAllowed(location.pathname)) {
    return <Navigate to={defaultRoute} replace />
  }

  return children
}
